import Axios from 'axios';

// Configuramos Axios
// Axios.defaults.baseURL = 'http://localhost:3000/';
// API_URL viene de la confguracion de entorno en /config
Axios.defaults.baseURL = process.env.API_URL;
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';



// WEBPACK FOOTER //
// ./src/config/axios.js